import classes from './AgreeModal.module.css';
import Modal from '../Modal';
import { faX } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import useEscModalClose from '../../../hooks/useEscModalClose';
import iconIsms from '../../../assets/img/icon_isms.png';

/**
 * 테스트 동의, 쇼핑몰 판매자 센터 접속 동의 모달 컴포넌트
 */
const AgreeModal = (props) => {
  useEscModalClose(props);

  const modalContent = [
    {
      type: 'test',
      title: '테스트 동의 안내',
      info: '플레이오토에서 문의사항을 해결하기 위해 테스트 하는 절차를 안내드릴게요!',
      content: [
        '문의주신 내용 확인 시 엔지니어가 문제 해결을 위한 디버그 모드 접속이 필요한지 여부를 판단해요.',
        '디버그 접속이 필요하다고 판단되면, 테스트에 동의해 주신 경우에만 디버그 모드로 접속하여 테스트를 진행해요.<br>테스트에 동의해 주셨더라도 디버그 접속이 필요하지 않은 경우에는 접속하지 않으니 안심하세요.',
        '디버그 모드로 확인할 수 없는 PC문제, 인터넷 환경, 브라우저 문제로 보여지는 경우에는<br>별도로 연락드려 엔지니어가 직접 원격으로 확인할 수 있어요.'
      ]
    },
    {
      type: 'connect',
      title: '쇼핑몰 판매자센터 접속 동의 안내',
      info: '플레이오토에서 문의사항을 해결하기 위해 부득이하게 쇼핑몰 판매자센터의 데이터 확인이 필요한 경우가 있어요!',
      content: [
        '문의주신 내용 확인 시 엔지니어가 문제 해결을 위해<br>쇼핑몰 판매자센터 상에서 데이터 확인이 필요한지 여부를 판단해요.',
        '판매자센터 접속이 필요하다고 판단되면, 연동된 ID로 판매자센터 바로 접속(솔루션 기능)으로 확인을 진행해요.<br>접속 동의해 주셨더라도 접속이 필요하지 않은 경우에는 접속하지 않으니 안심하세요.',
        '쇼핑몰 2단계 인증이나 비밀번호 변경 등으로 판매자센터 바로 접속이 안되는 경우에는<br>별도로 연락드려 확인 요청을 할 수 있어요.'
      ]
    }
  ]

  return (
    <Modal>
      <div className={classes.container}>
        <button onClick={props.closeModal} className={classes.close}>
          <FontAwesomeIcon icon={faX} />
        </button>
        <h2>
          {modalContent.find(item => item.type === props.type)?.title}
        </h2>
        <div className={classes.form}>
          <div>
            <img src={iconIsms} alt="ISMS 아이콘" />
          </div>
          <p className={classes['text-info']}>{modalContent.find(item => item.type === props.type)?.info}</p>
          <ul>
            {modalContent.find(item => item.type === props.type)?.content.map((text, index) => (
              <li key={index} className={classes['text-content']}>
                <span className={classes['text-number']}>{index + 1}</span><span dangerouslySetInnerHTML={{ __html: text }} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Modal>
    
  );
};

export default AgreeModal;